import { Stack, TextField } from "@mui/material";
import React from "react";
import TextFieldLabel from "./TextFieldLabel";
import { useField } from "formik";

export default function TextArea({ label, requiredMark, placeholder, name }) {
  const [field, meta] = useField(name);

  return (
    <Stack spacing={1}>
      <TextFieldLabel label={label} required={requiredMark} />
      <TextField
        {...field}
        placeholder={placeholder}
        multiline
        rows={4}
        variant="outlined"
        fullWidth
        error={meta.touched && Boolean(meta.error)}
        helperText={meta.touched && meta.error}
      />
    </Stack>
  );
}
